import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { formatServiceAddress } from '@wayste/client-utils';
import { BuildingStorefrontIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import { ResultWrapper } from './helper/resultWrapper';
export const TaggedContainerResult = ({ container }) => {
    const { onNavigate, onResetValues } = useContext(CustomFormContext);
    const handleRedirect = () => {
        if (container.id) {
            onNavigate(container, container.id, 'tagged-container');
            onResetValues('search');
        }
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(BuildingStorefrontIcon, { className: "size-4" }), container.name ? _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: container.name }) : _jsx(_Fragment, {}), container.lastActivity?.address ? (_jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: formatServiceAddress(container.lastActivity.address) })) : (_jsx(_Fragment, {})), container.decal ? _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: container.decal }) : _jsx(_Fragment, {})] }) }));
};
//# sourceMappingURL=tagged-container-result.js.map